import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {reaction} from 'mobx';
import isUndefined from 'lodash/isUndefined';
import isNumber from 'lodash/isNumber';
import * as d3 from 'd3';
import {TrackPlayStatus} from '../../../constants/enums';
import {getInnerRadius, getOuterRadius} from './studioUtility';

@inject('studioStore')
@observer
class StudioPlayerCursor extends Component {
    componentDidMount() {
        const {studioStore} = this.props;
        this.pathEl = d3.select('.studio-cursor');
        this.modifiedListener = reaction(
            () => studioStore.leaderTrack.lastModified,
            (lastModified) => {
                this.onTrackChange(lastModified, studioStore.leaderTrack.currentTime);
            },
            {}
        );

    }

    componentWillUnmount() {
        this.modifiedListener();
    }

    onTrackChange(lastModified, currentTime) {
        if (isNumber(lastModified)) {
            this.seekTo(currentTime, this.props.studioStore.leaderTrack.playStatus);
        }
    }

    playAnimation = () => {
        const {leaderTrack, duration} = this.props.studioStore;
        const {currentTime} = leaderTrack;
        const progress = currentTime / duration;
        const durationInMilis = duration * 1000;
        this.pathEl.transition().duration(durationInMilis).delay(0).ease(d3.easeLinear)
            .attrTween('transform', () => {
                return d3.interpolateString(`rotate(${360 * progress})`, `rotate(${(360 + (360 * progress))})`);
            });
    };

    seekTo(seekTo) {
        const {leaderTrack, duration} = this.props.studioStore;
        if (!isUndefined(seekTo)) {
            this.pauseAnimation();
            const progress = seekTo / duration;
            this.pathEl.attr('transform', `rotate(${360 * (progress)})`);
            if (leaderTrack.playStatus === TrackPlayStatus.Playing) {
                this.playAnimation();
            }
        }
    }

    pauseAnimation = () => {
        if (this.pathEl) {
            this.pathEl.interrupt();
        }
    };


    render() {
        return (
            <g>
                <circle className='studio-cursor-base-shadow' x={0} y={0} r={getInnerRadius(0)}/>
                <circle className='studio-cursor-base' x={0} y={0} r={18}/>
                <line className='studio-cursor' x1={0} y1={0} x2={0} y2={-getOuterRadius(6) - 4}/>
            </g>
        );
    }
}

export default StudioPlayerCursor;
